/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrGridColumnMoveOptions } from './igr-grid-column-move-options';
import { GridColumnMoveOptions } from './GridColumnMoveOptions';
import { TypeRegistrar } from "igniteui-react-core";
var IgrGridColumnMoveOptionsModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridColumnMoveOptionsModule() {
    }
    IgrGridColumnMoveOptionsModule.register = function () {
        TypeRegistrar.registerCons('IgrGridColumnMoveOptions', IgrGridColumnMoveOptions);
        TypeRegistrar.registerCons('IgrGridColumnMoveOptions', IgrGridColumnMoveOptions);
        TypeRegistrar.register('GridColumnMoveOptions', GridColumnMoveOptions.$type);
    };
    return IgrGridColumnMoveOptionsModule;
}());
export { IgrGridColumnMoveOptionsModule };
//# sourceMappingURL=igr-grid-column-move-options-module.js.map
